module.exports = __webpack_public_path__ + "static/img/people_default.af0ff38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/System/people_default.png
// module id = etGm
// module chunks = 4